export default "__VITE_ASSET__CRhDTnHq__"